/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { SalesBaseService } from '../sales-base-service';
import { SalesApiConfiguration } from '../sales-api-configuration';
import { SalesStrictHttpResponse } from '../sales-strict-http-response';

import { SalesQuoteLightDto } from '../models/sales-quote-light-dto';
import { SalesQuoteResponseDto } from '../models/sales-quote-response-dto';
import { quotesControllerAddTeamConfigurationItem } from '../fn/quotes/quotes-controller-add-team-configuration-item';
import { QuotesControllerAddTeamConfigurationItem$Params } from '../fn/quotes/quotes-controller-add-team-configuration-item';
import { quotesControllerAddVacationItem } from '../fn/quotes/quotes-controller-add-vacation-item';
import { QuotesControllerAddVacationItem$Params } from '../fn/quotes/quotes-controller-add-vacation-item';
import { quotesControllerCreate } from '../fn/quotes/quotes-controller-create';
import { QuotesControllerCreate$Params } from '../fn/quotes/quotes-controller-create';
import { quotesControllerFindAllByTenant } from '../fn/quotes/quotes-controller-find-all-by-tenant';
import { QuotesControllerFindAllByTenant$Params } from '../fn/quotes/quotes-controller-find-all-by-tenant';
import { quotesControllerFindLightByTenant } from '../fn/quotes/quotes-controller-find-light-by-tenant';
import { QuotesControllerFindLightByTenant$Params } from '../fn/quotes/quotes-controller-find-light-by-tenant';
import { quotesControllerFindOne } from '../fn/quotes/quotes-controller-find-one';
import { QuotesControllerFindOne$Params } from '../fn/quotes/quotes-controller-find-one';
import { quotesControllerRemove } from '../fn/quotes/quotes-controller-remove';
import { QuotesControllerRemove$Params } from '../fn/quotes/quotes-controller-remove';
import { quotesControllerRemoveTeamConfigurationItem } from '../fn/quotes/quotes-controller-remove-team-configuration-item';
import { QuotesControllerRemoveTeamConfigurationItem$Params } from '../fn/quotes/quotes-controller-remove-team-configuration-item';
import { quotesControllerRemoveVacationItem } from '../fn/quotes/quotes-controller-remove-vacation-item';
import { QuotesControllerRemoveVacationItem$Params } from '../fn/quotes/quotes-controller-remove-vacation-item';
import { quotesControllerUpdate } from '../fn/quotes/quotes-controller-update';
import { QuotesControllerUpdate$Params } from '../fn/quotes/quotes-controller-update';
import { quotesControllerUpdateTeamConfigurationItem } from '../fn/quotes/quotes-controller-update-team-configuration-item';
import { QuotesControllerUpdateTeamConfigurationItem$Params } from '../fn/quotes/quotes-controller-update-team-configuration-item';
import { quotesControllerUpdateVacationItem } from '../fn/quotes/quotes-controller-update-vacation-item';
import { QuotesControllerUpdateVacationItem$Params } from '../fn/quotes/quotes-controller-update-vacation-item';

@Injectable({ providedIn: 'root' })
export class SalesQuotesService extends SalesBaseService {
  constructor(config: SalesApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `quotesControllerFindAllByTenant()` */
  static readonly QuotesControllerFindAllByTenantPath = '/o2-sales/quotes/{tenant}';

  /**
   * Retrieve quotes by tenant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `quotesControllerFindAllByTenant()` instead.
   *
   * This method doesn't expect any request body.
   */
  quotesControllerFindAllByTenant$Response(params: QuotesControllerFindAllByTenant$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<Array<SalesQuoteResponseDto>>> {
    const obs = quotesControllerFindAllByTenant(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve quotes by tenant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `quotesControllerFindAllByTenant$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  quotesControllerFindAllByTenant(params: QuotesControllerFindAllByTenant$Params, context?: HttpContext): Observable<Array<SalesQuoteResponseDto>> {
    const resp = this.quotesControllerFindAllByTenant$Response(params, context);
    return resp.pipe(
      map((r: SalesStrictHttpResponse<Array<SalesQuoteResponseDto>>): Array<SalesQuoteResponseDto> => r.body)
    );
  }

  /** Path part for operation `quotesControllerCreate()` */
  static readonly QuotesControllerCreatePath = '/o2-sales/quotes/{tenant}';

  /**
   * Create a new quote.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `quotesControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  quotesControllerCreate$Response(params: QuotesControllerCreate$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesQuoteResponseDto>> {
    const obs = quotesControllerCreate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create a new quote.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `quotesControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  quotesControllerCreate(params: QuotesControllerCreate$Params, context?: HttpContext): Observable<SalesQuoteResponseDto> {
    const resp = this.quotesControllerCreate$Response(params, context);
    return resp.pipe(
      map((r: SalesStrictHttpResponse<SalesQuoteResponseDto>): SalesQuoteResponseDto => r.body)
    );
  }

  /** Path part for operation `quotesControllerFindLightByTenant()` */
  static readonly QuotesControllerFindLightByTenantPath = '/o2-sales/quotes/{tenant}/light';

  /**
   * Retrieve lightweight quotes by tenant (for dropdowns/selects).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `quotesControllerFindLightByTenant()` instead.
   *
   * This method doesn't expect any request body.
   */
  quotesControllerFindLightByTenant$Response(params: QuotesControllerFindLightByTenant$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<Array<SalesQuoteLightDto>>> {
    const obs = quotesControllerFindLightByTenant(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve lightweight quotes by tenant (for dropdowns/selects).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `quotesControllerFindLightByTenant$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  quotesControllerFindLightByTenant(params: QuotesControllerFindLightByTenant$Params, context?: HttpContext): Observable<Array<SalesQuoteLightDto>> {
    const resp = this.quotesControllerFindLightByTenant$Response(params, context);
    return resp.pipe(
      map((r: SalesStrictHttpResponse<Array<SalesQuoteLightDto>>): Array<SalesQuoteLightDto> => r.body)
    );
  }

  /** Path part for operation `quotesControllerFindOne()` */
  static readonly QuotesControllerFindOnePath = '/o2-sales/quotes/{tenant}/id/{id}';

  /**
   * Retrieve a quote by tenant and ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `quotesControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  quotesControllerFindOne$Response(params: QuotesControllerFindOne$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesQuoteResponseDto>> {
    const obs = quotesControllerFindOne(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve a quote by tenant and ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `quotesControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  quotesControllerFindOne(params: QuotesControllerFindOne$Params, context?: HttpContext): Observable<SalesQuoteResponseDto> {
    const resp = this.quotesControllerFindOne$Response(params, context);
    return resp.pipe(
      map((r: SalesStrictHttpResponse<SalesQuoteResponseDto>): SalesQuoteResponseDto => r.body)
    );
  }

  /** Path part for operation `quotesControllerRemove()` */
  static readonly QuotesControllerRemovePath = '/o2-sales/quotes/{tenant}/{id}';

  /**
   * Delete a quote by tenant and ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `quotesControllerRemove()` instead.
   *
   * This method doesn't expect any request body.
   */
  quotesControllerRemove$Response(params: QuotesControllerRemove$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesQuoteResponseDto>> {
    const obs = quotesControllerRemove(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete a quote by tenant and ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `quotesControllerRemove$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  quotesControllerRemove(params: QuotesControllerRemove$Params, context?: HttpContext): Observable<SalesQuoteResponseDto> {
    const resp = this.quotesControllerRemove$Response(params, context);
    return resp.pipe(
      map((r: SalesStrictHttpResponse<SalesQuoteResponseDto>): SalesQuoteResponseDto => r.body)
    );
  }

  /** Path part for operation `quotesControllerUpdate()` */
  static readonly QuotesControllerUpdatePath = '/o2-sales/quotes/{tenant}/{id}';

  /**
   * Update a quote by tenant and ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `quotesControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  quotesControllerUpdate$Response(params: QuotesControllerUpdate$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesQuoteResponseDto>> {
    const obs = quotesControllerUpdate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update a quote by tenant and ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `quotesControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  quotesControllerUpdate(params: QuotesControllerUpdate$Params, context?: HttpContext): Observable<SalesQuoteResponseDto> {
    const resp = this.quotesControllerUpdate$Response(params, context);
    return resp.pipe(
      map((r: SalesStrictHttpResponse<SalesQuoteResponseDto>): SalesQuoteResponseDto => r.body)
    );
  }

  /** Path part for operation `quotesControllerAddVacationItem()` */
  static readonly QuotesControllerAddVacationItemPath = '/o2-sales/quotes/{tenant}/{quoteId}/vacation-items';

  /**
   * Add a vacation item to a quote.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `quotesControllerAddVacationItem()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  quotesControllerAddVacationItem$Response(params: QuotesControllerAddVacationItem$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesQuoteResponseDto>> {
    const obs = quotesControllerAddVacationItem(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Add a vacation item to a quote.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `quotesControllerAddVacationItem$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  quotesControllerAddVacationItem(params: QuotesControllerAddVacationItem$Params, context?: HttpContext): Observable<SalesQuoteResponseDto> {
    const resp = this.quotesControllerAddVacationItem$Response(params, context);
    return resp.pipe(
      map((r: SalesStrictHttpResponse<SalesQuoteResponseDto>): SalesQuoteResponseDto => r.body)
    );
  }

  /** Path part for operation `quotesControllerRemoveVacationItem()` */
  static readonly QuotesControllerRemoveVacationItemPath = '/o2-sales/quotes/{tenant}/{quoteId}/vacation-items/{object}';

  /**
   * Remove a vacation item from a quote by object.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `quotesControllerRemoveVacationItem()` instead.
   *
   * This method doesn't expect any request body.
   */
  quotesControllerRemoveVacationItem$Response(params: QuotesControllerRemoveVacationItem$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesQuoteResponseDto>> {
    const obs = quotesControllerRemoveVacationItem(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Remove a vacation item from a quote by object.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `quotesControllerRemoveVacationItem$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  quotesControllerRemoveVacationItem(params: QuotesControllerRemoveVacationItem$Params, context?: HttpContext): Observable<SalesQuoteResponseDto> {
    const resp = this.quotesControllerRemoveVacationItem$Response(params, context);
    return resp.pipe(
      map((r: SalesStrictHttpResponse<SalesQuoteResponseDto>): SalesQuoteResponseDto => r.body)
    );
  }

  /** Path part for operation `quotesControllerUpdateVacationItem()` */
  static readonly QuotesControllerUpdateVacationItemPath = '/o2-sales/quotes/{tenant}/{quoteId}/vacation-items/{object}';

  /**
   * Update a vacation item in a quote by object.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `quotesControllerUpdateVacationItem()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  quotesControllerUpdateVacationItem$Response(params: QuotesControllerUpdateVacationItem$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesQuoteResponseDto>> {
    const obs = quotesControllerUpdateVacationItem(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update a vacation item in a quote by object.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `quotesControllerUpdateVacationItem$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  quotesControllerUpdateVacationItem(params: QuotesControllerUpdateVacationItem$Params, context?: HttpContext): Observable<SalesQuoteResponseDto> {
    const resp = this.quotesControllerUpdateVacationItem$Response(params, context);
    return resp.pipe(
      map((r: SalesStrictHttpResponse<SalesQuoteResponseDto>): SalesQuoteResponseDto => r.body)
    );
  }

  /** Path part for operation `quotesControllerAddTeamConfigurationItem()` */
  static readonly QuotesControllerAddTeamConfigurationItemPath = '/o2-sales/quotes/{tenant}/{quoteId}/team-configuration';

  /**
   * Add a team configuration item to a quote.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `quotesControllerAddTeamConfigurationItem()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  quotesControllerAddTeamConfigurationItem$Response(params: QuotesControllerAddTeamConfigurationItem$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesQuoteResponseDto>> {
    const obs = quotesControllerAddTeamConfigurationItem(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Add a team configuration item to a quote.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `quotesControllerAddTeamConfigurationItem$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  quotesControllerAddTeamConfigurationItem(params: QuotesControllerAddTeamConfigurationItem$Params, context?: HttpContext): Observable<SalesQuoteResponseDto> {
    const resp = this.quotesControllerAddTeamConfigurationItem$Response(params, context);
    return resp.pipe(
      map((r: SalesStrictHttpResponse<SalesQuoteResponseDto>): SalesQuoteResponseDto => r.body)
    );
  }

  /** Path part for operation `quotesControllerRemoveTeamConfigurationItem()` */
  static readonly QuotesControllerRemoveTeamConfigurationItemPath = '/o2-sales/quotes/{tenant}/{quoteId}/team-configuration/{itemId}';

  /**
   * Remove a team configuration item from a quote by name.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `quotesControllerRemoveTeamConfigurationItem()` instead.
   *
   * This method doesn't expect any request body.
   */
  quotesControllerRemoveTeamConfigurationItem$Response(params: QuotesControllerRemoveTeamConfigurationItem$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesQuoteResponseDto>> {
    const obs = quotesControllerRemoveTeamConfigurationItem(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Remove a team configuration item from a quote by name.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `quotesControllerRemoveTeamConfigurationItem$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  quotesControllerRemoveTeamConfigurationItem(params: QuotesControllerRemoveTeamConfigurationItem$Params, context?: HttpContext): Observable<SalesQuoteResponseDto> {
    const resp = this.quotesControllerRemoveTeamConfigurationItem$Response(params, context);
    return resp.pipe(
      map((r: SalesStrictHttpResponse<SalesQuoteResponseDto>): SalesQuoteResponseDto => r.body)
    );
  }

  /** Path part for operation `quotesControllerUpdateTeamConfigurationItem()` */
  static readonly QuotesControllerUpdateTeamConfigurationItemPath = '/o2-sales/quotes/{tenant}/{quoteId}/team-configuration/{itemId}';

  /**
   * Update a team configuration item in a quote by name.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `quotesControllerUpdateTeamConfigurationItem()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  quotesControllerUpdateTeamConfigurationItem$Response(params: QuotesControllerUpdateTeamConfigurationItem$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesQuoteResponseDto>> {
    const obs = quotesControllerUpdateTeamConfigurationItem(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update a team configuration item in a quote by name.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `quotesControllerUpdateTeamConfigurationItem$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  quotesControllerUpdateTeamConfigurationItem(params: QuotesControllerUpdateTeamConfigurationItem$Params, context?: HttpContext): Observable<SalesQuoteResponseDto> {
    const resp = this.quotesControllerUpdateTeamConfigurationItem$Response(params, context);
    return resp.pipe(
      map((r: SalesStrictHttpResponse<SalesQuoteResponseDto>): SalesQuoteResponseDto => r.body)
    );
  }

}
